// extracted by mini-css-extract-plugin
module.exports = {"order_content":"orderList_order_content__7QfmO","order_title_wrap":"orderList_order_title_wrap__N75_O","order_title":"orderList_order_title__XVLpr"};